// Flattens the control's bottom corners while the menu is open, so it reads
// as one continuous shape with the options list directly below it, then
// returns to fully rounded once closed. Matches the equivalent behavior
// applied to plain <select className="formInput"> elements site-wide
// (see select.formInput:focus in react_login.scss) — react-select renders
// its own divs instead of a native <select>, so that CSS rule can't reach
// it and this has to be done via react-select's own `styles` prop instead.
export const dropdownControlStyle = (base, state) => ({
  ...base,
  borderRadius: state.selectProps.menuIsOpen ? "8px 8px 0 0" : "8px",
})

// Spread into a component's own `styles` prop: `styles={{...reactSelectDropdownStyles, ...otherOverrides}}`
export const reactSelectDropdownStyles = {
  control: dropdownControlStyle,
}
